export default {
  impactTitle: 'Impact prévisionnel sur votre patrimoine',
  impactTitleMinor: 'Impact prévisionnel sur le patrimoine de votre enfant',
  impactTitlePro: 'Impact prévisionnel sur les actifs financiers de l’entreprise',
  currentSituationBadge: 'SITUATION ACTUELLE',
  afterSimulationBadge: 'APRÈS SIMULATION',
}
